import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import { useAuthStore } from './stores/authStore';

async function initApp() {
  const app = createApp(App);
  const pinia = createPinia();

  app.use(pinia);
  app.use(router);

  // Initialize auth store and wait for completion
  const authStore = useAuthStore();
  await authStore.initAuth();

  app.mount('#app');
}

initApp(); 